<template>
    <div id="listagem" class="container d-flex justify-content-center align-items-center" style="padding-bottom: 70px; padding-top: 10px;">
      <div class="text-center col-12 col-md-12">
        <h1 class="losta_masca" style="color: #114c74">Lista de fichas de decisões</h1>
        <div class="d-flex justify-content-between mb-2">
          <span class="filter_button" @click="showFilterModal">
            <el-icon style="font-size: 27px;"><Operation /></el-icon>
            Filtrar
          </span>

          <span class="quantidadeFichas">{{ items.total }}</span>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-12">
            <button @click="gerarPdf()" type="button" class="btn btn-danger col-12 download-pdf" style=" display: flex; justify-content: center; align-items: center; ">
              Baixar PDF
              <el-icon><Download /></el-icon>
            </button>
          </div>
        </div>
        <div class="row w-100" v-for="item in items.fichas" :key="item.id">
          <div class="card w-100" @click="goToFicha(item.num_ficha_colheita)">
            <div class="card-body">
                <p class="ficha_id">ID: {{ item.num_ficha_colheita }}</p>
                <h5 class="ficha_nome">{{ item.nome }}</h5>
                <p class="congregacao">{{ item.congregacao_nome }} (Setor {{ item.setor < 10 ? '0' + item.setor : item.setor }})</p>
                <p class="data_conversao">
                    <el-icon style="margin-right: 5px;"><Calendar /></el-icon>
                    {{ new Date(item.data_conversao + 'T12:00:00').toLocaleDateString('pt-BR') }}
                </p>
            </div>
          </div>
        </div>
        <el-pagination
            class="example-pagination-block d-flex justify-content-center"
            style="margin-bottom: 20px;"
            v-model:current-page="filters.page"
            :page-size="1"
            layout="prev, pager, next"
            @current-change="getFichas(filters)"
            :hide-on-single-page="true"
            :total="totalPages"
        />
      </div>

    </div>

    <div class="container d-flex justify-content-center align-items-center sem_fichas">
      <div class="alert alert-info text-center bg-transparent border-0 shadow-none" v-if="items.length == 0">
        <h3 style="color: rgb(17, 76, 116); font-family: Arial, Helvetica, sans-serif; font-weight: bold;">Olá, {{ user.cargo }}. {{ user.name }}!</h3>
        <p style="color: #9ca7b9;">Você não tem nenhuma ficha de decisão cadastrada.</p>
        <p style="color: rgb(17, 76, 116);">Clique no botão abaixo.</p>
      </div>
    </div>

    <div class="container position-fixed bottom-0 start-50 translate-middle-x py-3">
      <div class="row justify-content-center">
        <div class="col-12 col-md-12">
      <button class="btn btn-primary w-100 nova_ficha" style="height: 60px !important;" @click="novaFicha">
        Cadastrar nova decisão
      </button>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="filterModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="filterModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
            <form>
              
              <div class="mb-3" v-if="!resetarSelect && user.showCampoInput">
                <div class="form-floating">
                  <div class="el-float-label">
                    <label for="">Campo Eclesiástico</label>
                    <el-select
                      :teleported="false"
                      clearable
                      v-model="filters.campoSelected"
                      filterable
                      placeholder="Selecione"
                      style="width: 100%"
                      multiple
                    >
                      <el-option
                        v-for="campo in campos"
                        :key="campo.id"
                        :value="campo.id"
                        :label="campo.descricao"
                      />
                    </el-select>
                  </div>
                  <!-- <label for="campoSelect">Campo Eclesiástico</label> -->
                </div>
              </div>
              
              <div class="mb-3" v-if="!resetarSelect && user.showFilialInput">

                <div class="el-float-label">
                  <label for="">Filial</label>
                  <el-select
                    :teleported="false"
                    clearable
                    v-model="filters.igrejaSelected"
                    filterable
                    placeholder="Selecione"
                    style="width: 100%"
                    multiple
                  >
                    <el-option
                      v-for="igreja in igrejas" 
                      :key="igreja.id" 
                      :value="igreja.id"
                      :label="igreja.nome"
                    />
                  </el-select>
                </div>
              </div>

              <div class="mb-3" v-if="!resetarSelect && user.showSetorInput">
                <div class="form-floating">
                  <div class="el-float-label">
                    <label for="">Setor</label>
                    <el-select
                      :teleported="false"
                      clearable
                      v-model="filters.setorSelected"
                      filterable
                      placeholder="Selecione"
                      style="width: 100%"
                      multiple
                    >
                      <el-option
                        v-for="setor in setores"
                        :key="setor" 
                        :value="setor"
                        :label="setor < 10 ? '0' + setor : setor"
                      />
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="!resetarSelect && user.showCongregacaoInput">
                <div class="el-float-label">
                  <label for="">Congregação</label>
                  <el-select
                    :teleported="false"
                    clearable
                    v-model="filters.congregacaoSelected"
                    filterable
                    placeholder="Selecione"
                    style="width: 100%"
                    multiple
                    id="congregacaoSelect"
                  >
                    <el-option
                      v-for="congregacao in congregacoes"
                      :key="congregacao.id"
                      :value="congregacao.id"
                      :label="congregacao.nome"
                    />
                  </el-select>
                </div>
              </div>

              <div class="mb-3">
                 <div class="el-float-label">
                  <label for="">Nome completo</label>

                  <el-input 
                    style="height: 66px; border-radius: 8px !important;"
                    v-model="filters.nome" 
                    placeholder="Nome completo" 
                    id="nomeInput"
                  />
                </div>
              </div>

              <div class="mb-3">
                <div class="el-float-label">
                  <label for="">Local de decisão</label>
                  <el-select
                    :teleported="false"
                    clearable
                    v-model="filters.localDecisao"
                    filterable
                    placeholder="Selecione o local da decisão"
                    style="width: 100%"
                  >
                    <el-option value="" label="Selecione..."></el-option>
                    <el-option value="Templo" label="Templo"></el-option>
                    <el-option value="Ar livre" label="Ar livre"></el-option>
                    <el-option value="Trabalho" label="Trabalho"></el-option>
                    <el-option value="Residência" label="Residência"></el-option>
                    <el-option value="Outro" label="Outro"></el-option>
                  </el-select>
                </div>
              </div>

              <div class="mb-3">
                <div class="el-float-label">
                  <label for="">Tipo de decisão</label>
                  <el-select
                    clearable
                    v-model="filters.tipoDeDecisao"
                    filterable
                    placeholder="Selecione"
                    style="width: 100%"
                    :teleported="false"
                  >
                    <el-option value="" label="Selecione">Selecione...</el-option>
                    <el-option value="Conversão (Aceitou Jesus)" label="Conversão (Aceitou Jesus)">Conversão (Aceitou Jesus)</el-option>
                    <el-option value="Reconciliação (Voltou para Jesus)" label="Reconciliação (Voltou para Jesus)">Reconciliação (Voltou para Jesus)</el-option>
                  </el-select>
                </div>
              </div>

              <div class="mb-3">
                <div class="el-float-label">
                  <label for="">Pode ser visitado(a)</label>

                  <el-select
                    :teleported="false"
                    v-model="filters.podeSerVisitado"
                    clearable
                    filterable
                    placeholder="Selecione"
                    style="width: 100%"
                  >
                    <el-option value="" label="Selecione">Selecione...</el-option>
                    <el-option :value="1" label="Sim">Sim</el-option>
                    <el-option :value="0" label="Não">Não</el-option>
                  </el-select>
                </div>
              </div>

              <div class="mb-3">
                <div class="el-float-label">
                  <label for="">Data de decisão (Início)</label>

                  <el-date-picker
                    :teleported="false"
                    v-model="filters.dataDecisaoInicio"
                    type="date"
                    placeholder="Selecione Uma Data"
                    format="DD/MM/YYYY"
                    value-format="YYYY-MM-DD"
                    style="width: 100%; height: 66px;"
                  />

                </div>
              </div>

              <div class="mb-3">
                <div class="el-float-label">
                  <label for="">Data de decisão (Fim)</label>

                  <el-date-picker
                    :teleported="false"
                    v-model="filters.dataDecisaoFim"
                    type="date"
                    placeholder="Selecione Uma Data"
                    format="DD/MM/YYYY"
                    value-format="YYYY-MM-DD"
                    style="width: 100%; height: 66px;"
                  />

                </div>
              </div>

              <div class="mb-3">
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  type="button"
                  class="btn btn-primary submit_button w-100"
                  style="background-color: #136A9F; border-radius: .78rem;"
                  @click="getFichas(filters)"
                >
                  Aplicar Filtros
                </button>
              </div>

              <div class="mv-3" style="text-align: center;">
                <a
                  class="w-100"
                  style="cursor: pointer; color: rgb(19, 106, 159); text-decoration: none;"
                  @click="limparFiltros()"
                >
                  Limpar Filtros
                </a>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="pdfDateLimitModal" tabindex="-1" aria-labelledby="pdfDateLimitModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title" id="pdfDateLimitModalLabel" style="color: #114c74;">Período inválido para PDF</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" style="color: #5f6b7a;">
            É possível exportar somente o período de até 3 meses.
          </div>
          <div class="modal-footer border-0">
            <button type="button" class="btn btn-primary submit_button" data-bs-dismiss="modal" style="background-color: #136A9F; border-radius: .78rem; height: auto !important; padding: 10px 24px;">
              Entendi
            </button>
          </div>
        </div>
      </div>
    </div>

    <NotificationComponent
      titulo="Sucesso!"
      :mensagem="'Os dados foram salvos com sucesso.'"
    />

  </template>
  
<script>
  import environment from '@/config/environment';
  import * as bootstrap from 'bootstrap';
  import 'select2/dist/css/select2.css';
  import 'select2/dist/js/select2.full.js';
  import { ElNotification } from 'element-plus'

  export default {
    name: 'ListaComponent',
    data() {
      return {
        user: this.$root.user || {},
        token: this.$root.token || {},
        items: [],
        showCampoInput: false,
        filters: {
          page: 1,
          campoSelected: [],
          igrejaSelected: [],
          setorSelected: [],
          congregacaoSelected: [],
          nome: '',
          localDecisao: '',
          tipoDeDecisao: '',
          podeSerVisitado: '',
          dataDecisaoInicio: '',
          dataDecisaoFim: '',
        },
        campos: [],
        igrejas: [],
        setores: [],
        congregacoes: [],

        resetarSelect: false,
        isMounted: false,
        totalPages: 1,
      };
    },
    watch: {
      'filters.campoSelected'(newValue) {
        if (this.isMounted && newValue.length > 0) {
          this.filters.igrejaSelected = [];
          this.filters.page = 1; // Reseta para página 1 ao mudar campo
          this.changeSelects()
        }
      },
      'filters.igrejaSelected'(newValue) {
        if (this.isMounted && newValue.length > 0) {
          this.filters.setorSelected = [];
          this.filters.page = 1; // Reseta para página 1 ao mudar igreja
          this.changeSelects()
        }
      },
      'filters.setorSelected'(newValue) {
        if (this.isMounted && newValue.length > 0) {
          this.filters.congregacaoSelected = [];
          this.filters.page = 1; // Reseta para página 1 ao mudar setor
          this.changeSelects()
        }
      },
      'filters.congregacaoSelected'(newValue) {
        if (this.isMounted && newValue.length > 0) {
          this.filters.page = 1; // Reseta para página 1 ao mudar congregação
        }
      },
      filters: {
        handler(newFilters) {
          console.log('salvou filtro')
          // Salva os filtros específicos para este usuário
          const filterKey = `filters_user_${this.user.user_id}`;
          localStorage.setItem(filterKey, JSON.stringify(newFilters));
        },
        deep: true, // Garante que mudanças dentro do objeto sejam detectadas
      },
    },
    beforeUnmount() {
      this.user = this.$root.user;
    },
    beforeMount(){
      // Carrega os filtros específicos deste usuário
      const filterKey = `filters_user_${this.user.user_id}`;
      const savedFilters = localStorage.getItem(filterKey);
      console.log('filtros em cache', savedFilters)
      if (savedFilters) {
        this.filters = JSON.parse(savedFilters);
      }
    },
    mounted() {
      this.isMounted = true;

      if (this.user && !this.user.showCampoInput) {
        setTimeout(() => {
          this.filters.campoSelected = [this.user.campo_id];
        }, 5);
      }
      if (this.user && !this.user.showFilialInput) {
        setTimeout(() => {
          this.filters.igrejaSelected = [this.user.igreja_id];
        }, 5);
      }
      if (this.user && !this.user.showSetorInput) {
        setTimeout(() => {
          this.filters.setorSelected = [this.user.setor];
        }, 5);
      }
      if (this.user && !this.user.showCongregacaoInput) {
        setTimeout(() => {
          this.filters.congregacaoSelected = [this.user.congregacao_id];
        }, 5);
      }

      setTimeout(() => {
          this.changeSelects();
      }, 5);

      this.getFichas(this.filters);
    },
    methods: {
      getFichas(filters = {}) {
        const params = new URLSearchParams();
        if(this.user)
        {
          params.append('user_id', this.user.user_id);
        }
        if (filters.campoSelected.length) {
          params.append('campo_id', filters.campoSelected.join(','));
        }
        if (filters.igrejaSelected.length) {
          params.append('igreja_id', filters.igrejaSelected.join(','));
        }
        if (filters.setorSelected.length) {
          params.append('setor', filters.setorSelected.join(','));
        }
        if (filters.congregacaoSelected.length) {
          params.append('congregacao_id', filters.congregacaoSelected.join(','));
        }
        if (filters.page) {
          params.append('page', filters.page);
        }
        if (filters.nome) {
          params.append('nome', filters.nome);
        }
        if (filters.localDecisao) {
          params.append('local_decisao', filters.localDecisao);
        }
        if (filters.tipoDeDecisao) {
          params.append('tipo_de_decisao', filters.tipoDeDecisao);
        }
        if (filters.podeSerVisitado !== '') {
          params.append('pode_ser_visitado', filters.podeSerVisitado);
        }
        if (filters.dataDecisaoInicio) {
          const dataInicio = new Date(filters.dataDecisaoInicio);
          dataInicio.setDate(dataInicio.getDate()); // Add one day to the start date
          params.append('data_decisao_inicio', `${dataInicio.getFullYear()}-${(dataInicio.getMonth() + 1).toString().padStart(2, '0')}-${dataInicio.getDate().toString().padStart(2, '0')}`);
        }
        if (filters.dataDecisaoFim) {
          const dataFim = new Date(filters.dataDecisaoFim);
          dataFim.setDate(dataFim.getDate()); // Add one day to the end date
          params.append('data_decisao_fim', `${dataFim.getFullYear()}-${(dataFim.getMonth() + 1).toString().padStart(2, '0')}-${dataFim.getDate().toString().padStart(2, '0')}`);
        }

        console.log('token do usuario:', this.token)
        fetch(`${environment.apiUrl}colheita/getFichas?${params.toString()}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`
          },
          body: JSON.stringify({})
        })
          .then(response => response.json())
          .then(data => {
            this.items = data;
            console.log(data.totalPages)
            this.totalPages = Number(data.totalPages);

            // Se a página atual for maior que o total de páginas, reseta para página 1
            if (this.filters.page > this.totalPages && this.totalPages > 0) {
              console.log('Página atual maior que total de páginas, resetando para página 1');
              this.filters.page = 1;
              this.getFichas(this.filters);
            }
          });
      },
      goToFicha(id) {
        this.$router.push('/editar/' + id);
      },
      showFilterModal() {
        var filterModal = new bootstrap.Modal(document.getElementById('filterModal'));
        filterModal.show();
      },
      novaFicha() {
        this.$router.push('/nova_ficha');
      },
      parseDateString(dateString) {
        if (!dateString) {
          return null;
        }

        const [year, month, day] = dateString.split('-').map(Number);

        if (!year || !month || !day) {
          return null;
        }

        return new Date(year, month - 1, day);
      },
      addMonthsNoOverflow(date, months) {
        const baseDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const originalDay = baseDate.getDate();

        baseDate.setDate(1);
        baseDate.setMonth(baseDate.getMonth() + months);

        const lastDayOfTargetMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0).getDate();
        baseDate.setDate(Math.min(originalDay, lastDayOfTargetMonth));

        return baseDate;
      },
      isPdfDateRangeGreaterThanThreeMonths() {
        if (!this.filters.dataDecisaoInicio || !this.filters.dataDecisaoFim) {
          return false;
        }

        const inicio = this.parseDateString(this.filters.dataDecisaoInicio);
        const fim = this.parseDateString(this.filters.dataDecisaoFim);

        if (!inicio || !fim) {
          return false;
        }

        return fim > this.addMonthsNoOverflow(inicio, 3);
      },
      showPdfDateLimitModal() {
        const pdfDateLimitModal = new bootstrap.Modal(document.getElementById('pdfDateLimitModal'));
        pdfDateLimitModal.show();
      },
      changeSelects() {
        const params = new URLSearchParams();
        if (this.filters.campoSelected.length) {
          params.append('campo_id', this.filters.campoSelected.join(','));
        }
        if (this.filters.igrejaSelected.length) {
          params.append('igreja_id', this.filters.igrejaSelected.join(','));
        }
        if (this.filters.setorSelected.length) {
          params.append('setor', this.filters.setorSelected.join(','));
        }
        if (this.filters.congregacaoSelected.length) {
          params.append('congregacao_id', this.filters.congregacaoSelected.join(','));
        }
        if (this.user.user_id) {
          params.append('user_id', this.user.user_id);
        }

        const url = `${environment.apiUrl}congregacoes/getAllFilters?${params.toString()}`;
        fetch(url)
          .then(response => response.json())
          .then(data => {
            this.campos = data.campos;
            this.igrejas = data.igrejas;
            this.setores = data.setores;
            this.congregacoes = data.congregacoes;
          })
          .catch(error => {
            console.error('Erro ao buscar os dados:', error);
          });
      },
      gerarPdf()
      {
        if (this.isPdfDateRangeGreaterThanThreeMonths()) {
          this.showPdfDateLimitModal();
          return;
        }

        ElNotification({
          title: 'Criando seu PDF',
          message: 'Seu PDF esta sendo gerado, por favor aguarde',
          type: 'info', // info, success, warning, error
          duration: 5000,  // em milissegundos
        })
        var filters = this.filters;
        const params = new URLSearchParams();

        if (this.user) {
          params.append('user_id', this.user.user_id);
        }

        if (filters.campoSelected.length) {
          params.append('campo_id', filters.campoSelected.join(','));
        }
        if (filters.igrejaSelected.length) {
          params.append('igreja_id', filters.igrejaSelected.join(','));
        }
        if (filters.setorSelected.length) {
          params.append('setor', filters.setorSelected.join(','));
        }
        if (filters.congregacaoSelected.length) {
          params.append('congregacao_id', filters.congregacaoSelected.join(','));
        }
        if (filters.page) {
          params.append('page', filters.page);
        }
        if (filters.nome) {
          params.append('nome', filters.nome);
        }
        if (filters.localDecisao) {
          params.append('local_decisao', filters.localDecisao);
        }
        if (filters.tipoDeDecisao) {
          params.append('tipo_de_decisao', filters.tipoDeDecisao);
        }
        if (filters.podeSerVisitado !== '') {
          params.append('pode_ser_visitado', filters.podeSerVisitado);
        }
        if (filters.dataDecisaoInicio) {
          const dataInicio = new Date(filters.dataDecisaoInicio);
          dataInicio.setDate(dataInicio.getDate() + 1); // Add one day to the start date
          params.append('data_decisao_inicio', `${dataInicio.getFullYear()}-${(dataInicio.getMonth() + 1).toString().padStart(2, '0')}-${dataInicio.getDate().toString().padStart(2, '0')}`);
        }
        if (filters.dataDecisaoFim) {
          const dataFim = new Date(filters.dataDecisaoFim);
          dataFim.setDate(dataFim.getDate() + 1); // Add one day to the end date
          params.append('data_decisao_fim', `${dataFim.getFullYear()}-${(dataFim.getMonth() + 1).toString().padStart(2, '0')}-${dataFim.getDate().toString().padStart(2, '0')}`);
        }

        window.open(`${environment.apiUrl}colheita/download-pdf?${params.toString()}`, '_blank');


        // fetch(`${environment.apiUrl}colheita/download-pdf?${params.toString()}`, {
        //   method: 'GET',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({})
        // })
        // .then(response => response.blob())
        // .then(blob => {
        //   const url = window.URL.createObjectURL(blob);
        //   const a = document.createElement('a'); // cria o link invisível
        //   a.href = url;
        //   a.download = 'colheita.pdf';  // nome do arquivo
        //   a.target = '_blank';          // abre em nova aba
        //   a.click();                    // dispara o download
        //   window.URL.revokeObjectURL(url); // limpa o objeto URL
        // })
      },
      limparFiltros() {
        if (this.user.showCampoInput) {
          this.filters.campoSelected = [];
        }
        if (this.user.showFilialInput) {
          this.filters.igrejaSelected = [];
          this.igrejas = [];
        }
        if (this.user.showSetorInput) {
          this.filters.setorSelected = [];
          this.setores = [];
        }
        if (this.user.showCongregacaoInput) {
          this.filters.congregacaoSelected = [];
          this.congregacoes = [];
        }

        this.filters.nome = '';
        this.filters.localDecisao = '';
        this.filters.tipoDeDecisao = '';
        this.filters.podeSerVisitado = '';
        this.filters.dataDecisaoInicio = '';
        this.filters.dataDecisaoFim = '';
        this.filters.page = 1; // Reseta para página 1 ao limpar filtros
      },
    },
  }
</script>

<style>
    .card.w-100 {
        border-radius: 8px !important;
        border: none !important;
        background-color: #fff !important;
        margin-bottom: 10px !important;
        transition: .5s !important;
    }

    .w-100 {
      margin: auto !important;
    }

    .card:hover {
      cursor: pointer !important;
      background-color: #f0f0f0 !important;
      transition: .5s !important;
    }

    .filter_button {
        background-color: transparent;
        color: #136A9F;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .filter_icon {
        width: 25px;
    }

    .ficha_id {
        color: rgb(141, 153, 174);
        font-size: 12px;
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left;
    }

    .ficha_nome {
        color: #114c74;
        text-align: left;
        margin-bottom: 12px;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .data_conversao {
        color: #8d99ae;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: center;
    }

    .filter_button:hover {
        cursor: pointer;
    }

    .quantidadeFichas {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #114c74;
    }

    .congregacao {
      text-align: left;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      color: rgb(141, 153, 174);
      font-size: 12px;
      margin-bottom: 0px;
    }

    .submit_button {
      background-image: linear-gradient(
        to right bottom, 
        rgba(2, 132, 199, 0.75), 
        rgba(2, 132, 199, 0.95)
      ) !important;
      background-color: rgb(0, 0, 0) !important;
      border-color: rgba(2, 132, 199, 0.1) !important;
      color: rgb(255, 255, 255) !important;
      height: 66px !important;
    }

    .row {
      margin-left: 0;
      margin-right: 0;
    }

    .fixed-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1030;
      height: 60px;
      background-color: #114c74;
      border: 1px solid #114c74;
      border-radius: 8px;
      transition: background-color 0.3s, border-color 0.3s;
      font-weight: bolder;
    }

    .fixed-bottom:hover {
      background-color: transparent;
      border-color: #114c74;
      color: #114c74;
    }

    .select2-container .select2-selection--single, span.select2-selection.select2-selection--multiple {
      border-radius: .75rem !important;
      margin-bottom: 5px !important;
      min-height: 66px !important;
      border-color: rgb(229, 231, 235);
      display: flex;
      align-items: center;
    }

    .select2-container .select2-selection--multiple .select2-selection__rendered {
      margin-top: 33px;
    }

    .select2-selection__arrow, span.select2-selection.select2-selection--multiple {
      min-height: 66px !important;
      display: flex;
      align-items: end;
    }

    .select2-container--default .select2-selection--single .select2-selection__rendered {
      display: flex;
      justify-content: left;
      align-items: center;
      margin-left: 35px;
    }

    .select2-container {
      width: 100% !important;
    }

    .select2-dropdown {
      z-index: 9999 !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__rendered {
      margin-left: 4px;
    }

    .form-floating>label {
      align-items: baseline;
  }

  input#dataDecisaoFim, input#dataDecisaoInicio {
      padding-left: 14px !important;
  }

  .select2-container--default .select2-selection--single .select2-selection__rendered {
      margin-left: 4px !important;
  }
  .nova_ficha {
      background: #114c74 !important;
      border: 1px solid #114c74 !important;
      font-weight: bolder !important;
      transition: .5s !important;
  }

  .nova_ficha:hover {
    background: transparent !important;
    color: #114c74 !important;
    transition: .5s !important;
  }
  .sem_fichas{
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }

    button.btn-prev.is-first, button.btn-next.is-last {
        height: 60px;
    }
    button.btn-prev.is-first {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    button.btn-next.is-last {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    .el-pager, .el-pager li {
        height: 60px !important;
    }

    .download-pdf {
        background: transparent !important;
        color: #dc3545 !important;
        transition: .5s !important;
        font-weight: bolder !important;
    }

    .download-pdf:hover {
        background: #dc3545 !important;
        color: white !important;
        transition: .5s !important;
    }

</style>
